import { useState } from "react";
import { Plane, ExternalLink } from "lucide-react";

const Flights = () => {
  const providers = [
    {
      name: "Skyscanner",
      url: "https://www.skyscanner.com",
      description: "Compare millions of flights",
      color: "from-cyan-400 to-sky-500",
      iconBg: "bg-gradient-to-br from-cyan-500 to-sky-600",
    },
    {
      name: "Google Flights",
      url: "https://www.google.com/travel/flights",
      description: "Search & track flight prices",
      color: "from-blue-400 to-indigo-500",
      iconBg: "bg-gradient-to-br from-blue-500 to-indigo-600",
    },
    {
      name: "Momondo",
      url: "https://www.momondo.com",
      description: "Find the cheapest flights",
      color: "from-orange-400 to-amber-500",
      iconBg: "bg-gradient-to-br from-orange-500 to-amber-600",
    },
    {
      name: "Kiwi.com",
      url: "https://www.kiwi.com",
      description: "Unique flight combinations",
      color: "from-emerald-400 to-teal-500",
      iconBg: "bg-gradient-to-br from-emerald-500 to-teal-600",
    },
    {
      name: "Kayak",
      url: "https://www.kayak.com/flights",
      description: "Compare hundreds of sites",
      color: "from-red-400 to-rose-500",
      iconBg: "bg-gradient-to-br from-red-500 to-rose-600",
    },
    {
      name: "Expedia",
      url: "https://www.expedia.com/Flights",
      description: "Flights, hotels & packages",
      color: "from-yellow-400 to-amber-500",
      iconBg: "bg-gradient-to-br from-yellow-500 to-amber-600",
    },
  ];

  return (
    <div className="page-container" data-testid="flights-page">
      <div className="pb-28">
        {/* Hero Banner */}
        <div className="relative h-36 sm:h-44 overflow-hidden mb-6">
          <img src="https://images.unsplash.com/photo-1540339832862-474599807836?w=1200&q=80" alt="" className="w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#080d19]/80 via-[#080d19]/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4 pb-5">
            <h1 className="text-2xl font-bold font-heading text-white drop-shadow-lg">Flights</h1>
            <p className="text-sm text-slate-300/80 mt-0.5 drop-shadow">Book flights with trusted providers</p>
          </div>
        </div>
        <div className="px-4">

        {/* Provider Cards */}
        <div>
          <h2 className="text-lg font-semibold text-white mb-4">Flight Booking Sites</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {providers.map((provider, idx) => (
              <a
                key={idx}
                href={provider.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`glass-card p-4 hover:scale-[1.02] transition-all group border-2 border-transparent hover:border-white/20`}
                style={{
                  background: `linear-gradient(135deg, rgba(0,0,0,0.4), rgba(0,0,0,0.6)), linear-gradient(135deg, var(--tw-gradient-from), var(--tw-gradient-to))`,
                }}
                data-testid={`provider-${provider.name.toLowerCase().replace(/\./g, "")}`}
              >
                <div className="flex items-center gap-4">
                  <div
                    className={`w-14 h-14 rounded-xl ${provider.iconBg} flex items-center justify-center shadow-lg`}
                  >
                    <Plane className="w-7 h-7 text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-bold text-white text-lg">{provider.name}</h3>
                      <ExternalLink className="w-4 h-4 text-white/60 group-hover:text-white transition-colors" />
                    </div>
                    <p className="text-sm text-white/70">{provider.description}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Tips */}
        <div className="mt-6 glass-card p-4">
          <h3 className="font-semibold text-white mb-3">Flight Booking Tips</h3>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Book 6-8 weeks in advance for best prices
            </li>
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Tuesday and Wednesday are often cheapest days to fly
            </li>
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Compare prices across multiple sites
            </li>
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Check baggage fees - they can vary significantly
            </li>
          </ul>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Flights;
